import React from 'react'
import Style from '../viewSummary.module.css'
import { formatCount, percent } from '../summaryFormat'

const Tile = ({ tone, icon, label, value, hint, onOpen, isLoading }) => {
    const clickable = !isLoading && value > 0
    const Tag = clickable ? 'button' : 'div'
    return (
        <Tag
            type={clickable ? 'button' : undefined}
            className={[Style.kpi, Style[`kpi_${tone}`], clickable ? Style.kpiClickable : ''].join(' ')}
            onClick={clickable ? onOpen : undefined}
            title={clickable ? `View ${label.toLowerCase()} records` : undefined}
        >
            <span className={Style.kpiIcon}>
                <i className={icon} aria-hidden="true" />
            </span>
            <span className={Style.kpiBody}>
                <span className={Style.kpiLabel}>{label}</span>
                <span className={Style.kpiValue}>{isLoading ? <span className={Style.skeleton} style={{ width: 48, height: 20 }} /> : formatCount(value)}</span>
                <span className={Style.kpiHint}>{isLoading ? ' ' : hint}</span>
            </span>
            {clickable ? <i className={`uil-angle-right ${Style.kpiChevron}`} aria-hidden="true" /> : null}
        </Tag>
    )
}

const KpiStrip = ({ totals, entityCount, onOpen, isLoading }) => {
    const { total, completed, inFlight, error } = totals
    return (
        <div className={Style.kpis}>
            <Tile
                tone="primary"
                icon="uil-layers"
                label="Total records"
                value={total}
                hint={`Across ${entityCount} ${entityCount === 1 ? 'entity' : 'entities'}`}
                onOpen={() => onOpen('total')}
                isLoading={isLoading}
            />
            <Tile
                tone="success"
                icon="uil-check-circle"
                label="Completed"
                value={completed}
                hint={total > 0 ? `${percent(completed, total)}% completion rate` : 'Nothing synced yet'}
                onOpen={() => onOpen('completed')}
                isLoading={isLoading}
            />
            <Tile
                tone="info"
                icon="uil-sync"
                label="In progress"
                value={inFlight}
                hint={inFlight > 0 ? 'Awaiting completion' : 'Nothing pending'}
                onOpen={() => onOpen('inProgress')}
                isLoading={isLoading}
            />
            <Tile
                tone={!isLoading && error > 0 ? 'danger' : 'neutral'}
                icon="uil-exclamation-triangle"
                label="Failed"
                value={error}
                hint={error > 0 ? `${percent(error, total)}% of records need attention` : 'No failures'}
                onOpen={() => onOpen('error')}
                isLoading={isLoading}
            />
        </div>
    )
}

export default KpiStrip
